import Config from '~/client/src/shared/Config'

// The export bakes the Mapbox basemap into the file, which the current licence does not cover
// outside development.
export const isMapExportEnvironment = (): boolean =>
  (Config.ENVIRONMENT || '').toLowerCase() === 'development'
